export default "__VITE_PUBLIC_ASSET__cce837b2__"